<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.93189 9.99984L13.0486 15.2057C13.3952 15.509 13.4302 16.0357 13.1269 16.3815C12.8236 16.7282 12.2969 16.7632 11.9511 16.4607L6.11772 10.6265C5.73855 10.2948 5.73855 9.70484 6.11772 9.37317L11.9511 3.53984C12.2969 3.23651 12.8236 3.27151 13.1269 3.61734C13.4302 3.96401 13.3952 4.49067 13.0486 4.79317L7.93189 9.99984Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
